import { Theme } from "../../../../components/constants";

export default {
    actionsRow: {
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'space-between'
    },
    actionRowLeftColumn: {
        display: 'flex', 
        gap: '20px'
    },
    checkboxWithLabel: {
        display: 'flex', 
        gap: '10px'
    },
    text: { 
        fontSize: "16px",
        color: Theme.TEXT_PRIMARY_BLACK, 
        whiteSpace: 'pre' 
    },
    actionRowRightColumn: {
        display: 'flex', 
        gap: '20px', 
        alignItems: 'center'
    },
    groupIDCustomPopupSyles: {
        maxHeight: "80vh", 
        display: "flex", 
        flexDirection: "column"
    },
    groupIDChildrenStyles: {
        maxHeight:"100%", 
        paddingBottom: '50px'
    },
    groupIDList: {
        padding: '10px 40px 0px', 
        display: 'flex', 
        flexDirection: 'column', 
        gap:'20px'
    },
    groupIDListCheckbox: {
        display: 'flex', 
        gap: '10px'
    },
    groupPopupButtonRow: {
        display:'flex', 
        padding: '20px 40px 0px'
    },
    fullWidth: {
        width: '100%'
    },

}